import { resolveIdentifier } from 'mobx-state-tree';
import {
  RouteTimelineDtoModel, RouteTimelineDtoModelType, VisitDtoModel, VisitDtoModelType,
} from '../../models';
import { ItemsArrayModelType } from '../models/ItemsArray';

export const getItemizedStops = (self: any, acc: ItemsArrayModelType | undefined, stops: string[] | undefined): RouteTimelineDtoModelType[] => {
  const items: RouteTimelineDtoModelType[] = [];
  stops?.forEach((id: string) => {
    if (acc?.stops?.find((v: RouteTimelineDtoModelType) => v?.id === id) == null) {
      const event = resolveIdentifier(RouteTimelineDtoModel, self, id);
      if (event?.orders?.[0]?.id) {
        items.push(event);
      }
    }
  });
  return items;
};

export const getItemizedOrders = (self: any, acc: ItemsArrayModelType | undefined, orders: string[] | undefined): VisitDtoModelType[] => {
  const items: VisitDtoModelType[] = [];
  orders?.forEach((id: string) => {
    if (acc?.unscheduledOrders?.find((v: VisitDtoModelType) => v?.id === id) == null) {
      const order = resolveIdentifier(VisitDtoModel, self, id);
      if (order) {
        const visitId = order?.id;
        if (visitId) {
          items.push(order);
        }
      }
    }
  });
  return items;
};
